import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Globals } from 'projects/core/src/globals';
import { Model } from 'projects/core/src/include/model';
import { UserList } from 'projects/core/src/include/structures';
import { UserListService } from 'projects/core/src/lib/userlist.service';

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrl: './userlist.component.css'
})

export class UserlistComponent extends Model<UserList> implements OnInit,AfterViewInit {

  constructor(
      private route1: ActivatedRoute,
      private userlistsService: UserListService,
    ){
      super(route1,userlistsService); 
    }

showNoUser=false;
listUsers: UserList[]=[];

ngOnInit (): void {

    this.title = 'Dettaglio gruppo';
    this.record=new UserList();
    super.ngOnInit();

    Globals.setLoading(true);
    this.getItem();

    Globals.setLoading(false);
}

  
getUsersByIdList(){
  Globals.setLoading(true);  
  this.userlistsService.getUsersByIdList(this.record.id).subscribe((result)=>{
    this.listUsers=result;
    if(this.listUsers.length==0){
      this.showNoUser=true;
      setTimeout(()=>{
        this.showNoUser=false;
        
      },5000);      
    };
    Globals.setLoading(false);
  });
}

}